import {
  EmptyState,
  Spacer,
  TextBody,
  TextSubtitle,
} from '@pypestream/design-system';
import { FC } from 'react';

/**
 * The shared "nothing here yet" panel for the Project Settings lists.
 *
 * `DataTable` renders nothing but its header row when `data` is empty, which
 * reads as a broken screen rather than an empty one — so the pages swap the
 * table (or card list) for this instead.
 *
 * Deliberately text-only: every one of these screens already has its primary
 * action in the section header, and a second CTA here would compete with it.
 *
 * Callers MUST gate this on their `hasLoaded` flag. Keying off `rows.length`
 * alone would flash "no platforms" while the first request is still in flight.
 */
export const SettingsEmptyState: FC<{
  /** One short line naming what is missing, e.g. "No platforms yet". */
  title: string;
  /** What the user would do about it, or why the list is empty. */
  description: string;
  testId?: string;
}> = ({ title, description, testId }) => (
  <EmptyState test-id={testId}>
    <TextSubtitle size="small" textAlign="center">
      {title}
    </TextSubtitle>
    <Spacer size="2xsmall" />
    <TextBody size="small" variant="secondary" textAlign="center">
      {description}
    </TextBody>
  </EmptyState>
);
